if (!customElements.get('ff-gallery-modal')) {
  class FFGalleryModal extends HTMLElement {
    connectedCallback() {
      this.modalId = this.id || `ff-gallery-modal-${Date.now()}`;
      this.closeButton = this.querySelector('[data-ff-modal-close]');
      this.closeButton?.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => {
        if (this.hasAttribute('open') && e.key === 'Escape') this.close();
      });
      document.addEventListener('ff-gallery-modal:open', (e) => {
        if (e.detail.modalId === this.modalId) this.open(e.detail.index);
      });
      // Sync with main gallery when slide changes (update silently without animation)
      document.addEventListener('ff-gallery-modal:sync', (e) => {
        if (e.detail.modalId === this.modalId) this.syncSlide(e.detail.index);
      });
    }

    /**
     * Sync modal slider to match main gallery (silent, no animation)
     */
    syncSlide(index) {
      if (this.hasAttribute('open')) return; // Don't sync while open
      const slider = this.querySelector('ff-slider[data-ff-main-id]');
      if (!slider?.splide) return;

      // Use Splide's go() with jump option to move without animation
      const targetIndex = index - 1;
      if (slider.splide.index !== targetIndex) {
        // Temporarily disable transition for instant jump
        const list = slider.querySelector('.splide__list');
        if (list) {
          list.style.transition = 'none';
          slider.splide.go(targetIndex);
          // Re-enable transition after a frame
          requestAnimationFrame(() => {
            list.style.transition = '';
          });
        }
      }
    }

    open(index = 1) {
      if (this.hasAttribute('open')) return;
      const slider = this.querySelector('ff-slider[data-ff-main-id]');
      if (slider?.splide) {
        slider.splide.go(index - 1);
        this._initScaleEffect(slider);
      }
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    _initScaleEffect(slider) {
      if (this._scaleEffectReady) return;
      this._scaleEffectReady = true;
      slider.splide.on('move', () => slider.classList.add('ff-gallery-slider--moving'));
      slider.splide.on('moved', () => slider.classList.remove('ff-gallery-slider--moving'));
    }

    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      document.body.style.overflow = '';
    }
  }
  customElements.define('ff-gallery-modal', FFGalleryModal);
}
